var each = {exports: {}};

export { each as e };
